module.exports = __webpack_public_path__ + "img/SketchPng550f78b74638d0d7a69ce96e74e460ff1eccf14caf1fe8ff81b61543cf6941bf.852e977e.png";